import React from 'react';
import Img from 'gatsby-image';
import styled from 'styled-components';

const Container = styled.div`
  background: #f0f0f0;
`;

// Art direction (different aspect ratio) fix for gatsby
// https://github.com/gatsbyjs/gatsby/pull/13395#issuecomment-506402173
const ResponsiveImage = styled(Img)`
  & > div:first-child {
    padding-bottom: ${({ fluid }) => 100 / fluid[0].aspectRatio}% !important;

    @media (min-width: 768px) {
      padding-bottom: ${({ fluid }) => 100 / fluid[1].aspectRatio}% !important;
    }
  }
`;

export default ({ data }) => {
  const sources = [
    data.mobileImage.childImageSharp.fluid,
    {
      ...data.desktopImage.childImageSharp.fluid,
      media: `(min-width: 768px)`
    }
  ];
  return (
    <Container>
      <ResponsiveImage fluid={sources} loading="eager" />
    </Container>
  );
};
